import { ESortOrder } from "@domains/utils/sort";
import { HoldingReportData, } from "@domains/aggregates/interfaces/Reports/iHoldingReport";
import { Filters, SortData, } from "@domains/aggregates/interfaces/Reports/iReportsCommon";
import { BaseUseCase } from "@domains/useCases/UseCaseBase";
import { AssetCategory, } from "@domains/aggregates/interfaces/Reports/iPNLReport";
import { assetFilter, assetWiseProducts, simpleFilter, } from "@domains/mapper/Reports/AssetsAndProducts";
class HoldingReportUseCase extends BaseUseCase {
    constructor(holdingReportRepo) {
        super();
        this.holdingReportRepo = holdingReportRepo;
    }
    async fetchResult(req) {
        const homeDTOList = await this.holdingReportRepo.getHoldingReportData(req);
        const ArrayOfSortData = new Array(new SortData("Alphabetical", "displayName", ESortOrder.DESC), new SortData("P&L %", "pnlChangePercentage", ESortOrder.UNCHANGED), new SortData("P&L absolute", "pnl", ESortOrder.UNCHANGED), new SortData("LTP Change %", "changePercentage", ESortOrder.UNCHANGED), new SortData("Day Change", "dayChange", ESortOrder.UNCHANGED), new SortData("Investment Value", "investmentValue", ESortOrder.UNCHANGED), new SortData("Current Value", "currentValue", ESortOrder.UNCHANGED));
        let allAssetProducts = []; // set does not work  for non primitive  data types
        assetWiseProducts.get(AssetCategory.Total).map((product) => {
            allAssetProducts.push({
                title: product.display,
                key: product.value,
                selected: false,
            });
        });
        const productAssetFilter = new Filters("Product Asset filter", allAssetProducts);
        if (homeDTOList) {
            const finalData = new HoldingReportData(homeDTOList.HoldingSummary, homeDTOList.HoldingDetails, "", { simpleFilter, assetFilter, productAssetFilter }, ArrayOfSortData, false, {
                isOmneOnly: homeDTOList === null || homeDTOList === void 0 ? void 0 : homeDTOList.isOmneOnly, bodProcessInfoMessage: homeDTOList === null || homeDTOList === void 0 ? void 0 : homeDTOList.bodProcessInfoMessage, isBodEnabled: homeDTOList === null || homeDTOList === void 0 ? void 0 : homeDTOList.isBodEnabled
            });
            return finalData;
        }
        return null;
    }
}
export default HoldingReportUseCase;
